module.exports = __webpack_public_path__ + "static/media/dessert-1786311_1280.fbbca6ae.jpg";